'use client';
import { PlayerInfoPartnerLeague } from '@/modules/league/new-components/matches-components/MatchesComponent/MatchCard/PlayerInfoPartnerLeague';
import { PlayerInfoRegularLeague } from '@/modules/league/new-components/matches-components/MatchesComponent/MatchCard/PlayerInfoRegularLeague';
import { LeagueGameDayHeaderDetails, MatchesPlayers } from '@/modules/league/new-components/types';

interface PlayerBoxProps {
  player: MatchesPlayers;
  session: LeagueGameDayHeaderDetails;
  userUuid: string | undefined;
  teamNumber: number;
}

export const PlayerBoxFirstTeam = ({ player, session, userUuid }: PlayerBoxProps) => (
  <div className='flex flex-col gap-3'>
    {player.PlayerTypeTitle === 'Partner' ? (
      <PlayerInfoPartnerLeague
        poolSeedNumber={player.PT1a_PoolSeedNumber || player.PT1b_PoolSeedNumber}
        firstNameFirstPlayer={player.T1a_FirstName}
        lastNameFirstPlayer={player.T1a_LastName}
        firstNameSecondPlayer={player.T1b_FirstName}
        lastNameSecondPlayer={player.T1b_LastName}
        showBothIconsFirstPlayer={
          player.FirstServer_SessionTeamID === player.T1a_SessionTeamID &&
          player.PickSide_SessionTeamID === player.T1a_SessionTeamID &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showBothIconsSecondPlayer={
          player.FirstServer_SessionTeamID === player.T1b_SessionTeamID &&
          player.PickSide_SessionTeamID === player.T1b_SessionTeamID &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showIconFirst={
          (player.FirstServer_SessionTeamID === player.T1a_SessionTeamID ||
            player.PickSide_SessionTeamID === player.T1a_SessionTeamID) &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showIconSecond={
          (player.FirstServer_SessionTeamID === player.T1b_SessionTeamID ||
            player.PickSide_SessionTeamID === player.T1b_SessionTeamID) &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        iconLabelFirst={
          player.FirstServer_SessionTeamID === player.T1a_SessionTeamID
            ? 'S'
            : player.PickSide_SessionTeamID === player.T1a_SessionTeamID
              ? 'E'
              : ''
        }
        iconLabelSecond={
          player.FirstServer_SessionTeamID === player.T1b_SessionTeamID
            ? 'S'
            : player.PickSide_SessionTeamID === player.T1b_SessionTeamID
              ? 'E'
              : ''
        }
        subbedFirstPlayer={player.T1a_SubbedPlayer}
        subbedSecondPlayer={player.T1b_SubbedPlayer}
        isUserFirstPlayer={userUuid === player.T1a_UserID}
        isUserSecondPlayer={userUuid === player.T1b_UserID}
      />
    ) : (
      <>
        <PlayerInfoRegularLeague
          poolSeedNumber={player.PT1a_PoolSeedNumber}
          firstName={player.T1a_FirstName}
          lastName={player.T1a_LastName}
          showIconFirst={
            player.FirstServer_SessionTeamID === player.T1a_SessionTeamID &&
            session.serveAndEnd?.toLowerCase() !== 'hide'
          }
          iconLabelFirst={player.FirstServer_SessionTeamID === player.T1a_SessionTeamID ? 'S' : ''}
          showIconSecond={
            player.PickSide_SessionTeamID === player.T1a_SessionTeamID &&
            session.serveAndEnd?.toLowerCase() !== 'hide'
          }
          iconLabelSecond={player.PickSide_SessionTeamID === player.T1a_SessionTeamID ? 'E' : ''}
          subbedPlayer={player.T1a_SubbedPlayer}
          isUserAlsoPlayer={userUuid === player.T1a_UserID}
        />
        {player.PT1b_PoolSeedNumber ? (
          <PlayerInfoRegularLeague
            poolSeedNumber={player.PT1b_PoolSeedNumber}
            firstName={player.T1b_FirstName}
            lastName={player.T1b_LastName}
            showIconFirst={
              player.FirstServer_SessionTeamID === player.T1b_SessionTeamID &&
              session.serveAndEnd?.toLowerCase() !== 'hide'
            }
            iconLabelFirst={
              player.FirstServer_SessionTeamID === player.T1b_SessionTeamID ? 'S' : ''
            }
            showIconSecond={
              player.PickSide_SessionTeamID === player.T1b_SessionTeamID &&
              session.serveAndEnd?.toLowerCase() !== 'hide'
            }
            iconLabelSecond={player.PickSide_SessionTeamID === player.T1b_SessionTeamID ? 'E' : ''}
            subbedPlayer={player.T1b_SubbedPlayer}
            isUserAlsoPlayer={userUuid === player.T1b_UserID}
          />
        ) : null}
      </>
    )}
  </div>
);

export const PlayerBoxSecondTeam = ({ player, session, userUuid }: PlayerBoxProps) => (
  <div className='flex flex-col gap-3'>
    {player.PlayerTypeTitle === 'Partner' ? (
      <PlayerInfoPartnerLeague
        poolSeedNumber={player.PT2a_PoolSeedNumber || player.PT2b_PoolSeedNumber}
        firstNameFirstPlayer={player.T2a_FirstName}
        lastNameFirstPlayer={player.T2a_LastName}
        firstNameSecondPlayer={player.T2b_FirstName}
        lastNameSecondPlayer={player.T2b_LastName}
        showBothIconsFirstPlayer={
          player.FirstServer_SessionTeamID === player.T2a_SessionTeamID &&
          player.PickSide_SessionTeamID === player.T2a_SessionTeamID &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showBothIconsSecondPlayer={
          player.FirstServer_SessionTeamID === player.T2b_SessionTeamID &&
          player.PickSide_SessionTeamID === player.T2b_SessionTeamID &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showIconFirst={
          (player.FirstServer_SessionTeamID === player.T2a_SessionTeamID ||
            player.PickSide_SessionTeamID === player.T2a_SessionTeamID) &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        showIconSecond={
          (player.FirstServer_SessionTeamID === player.T2b_SessionTeamID ||
            player.PickSide_SessionTeamID === player.T2b_SessionTeamID) &&
          session.serveAndEnd?.toLowerCase() !== 'hide'
        }
        iconLabelFirst={
          player.FirstServer_SessionTeamID === player.T2a_SessionTeamID
            ? 'S'
            : player.PickSide_SessionTeamID === player.T2a_SessionTeamID
              ? 'E'
              : ''
        }
        iconLabelSecond={
          player.FirstServer_SessionTeamID === player.T2b_SessionTeamID
            ? 'S'
            : player.PickSide_SessionTeamID === player.T2b_SessionTeamID
              ? 'E'
              : ''
        }
        subbedFirstPlayer={player.T2a_SubbedPlayer}
        subbedSecondPlayer={player.T2b_SubbedPlayer}
        isUserFirstPlayer={userUuid === player.T2a_UserID}
        isUserSecondPlayer={userUuid === player.T2b_UserID}
      />
    ) : (
      <>
        <PlayerInfoRegularLeague
          poolSeedNumber={player.PT2a_PoolSeedNumber}
          firstName={player.T2a_FirstName}
          lastName={player.T2a_LastName}
          showIconFirst={
            player.FirstServer_SessionTeamID === player.T2a_SessionTeamID &&
            session.serveAndEnd?.toLowerCase() !== 'hide'
          }
          iconLabelFirst={player.FirstServer_SessionTeamID === player.T2a_SessionTeamID ? 'S' : ''}
          showIconSecond={
            player.PickSide_SessionTeamID === player.T2a_SessionTeamID &&
            session.serveAndEnd?.toLowerCase() !== 'hide'
          }
          iconLabelSecond={player.PickSide_SessionTeamID === player.T2a_SessionTeamID ? 'E' : ''}
          subbedPlayer={player.T2a_SubbedPlayer}
          isUserAlsoPlayer={userUuid === player.T2a_UserID}
        />
        {player.PT2b_PoolSeedNumber ? (
          <PlayerInfoRegularLeague
            poolSeedNumber={player.PT2b_PoolSeedNumber}
            firstName={player.T2b_FirstName}
            lastName={player.T2b_LastName}
            showIconFirst={
              player.FirstServer_SessionTeamID === player.T2b_SessionTeamID &&
              session.serveAndEnd?.toLowerCase() !== 'hide'
            }
            iconLabelFirst={
              player.FirstServer_SessionTeamID === player.T2b_SessionTeamID ? 'S' : ''
            }
            showIconSecond={
              player.PickSide_SessionTeamID === player.T2b_SessionTeamID &&
              session.serveAndEnd?.toLowerCase() !== 'hide'
            }
            iconLabelSecond={player.PickSide_SessionTeamID === player.T2b_SessionTeamID ? 'E' : ''}
            subbedPlayer={player.T2b_SubbedPlayer}
            isUserAlsoPlayer={userUuid === player.T2b_UserID}
          />
        ) : null}
      </>
    )}
  </div>
);
